import React, { useState, useEffect } from 'react';
import { useTranscriptionStore } from '../../store';
import {
  CheckCircle,
  AlertTriangle,
  Info,
  X,
  Wifi,
  WifiOff
} from 'lucide-react';

export const NotificationToast = () => {
  const { errors, dismissError } = useTranscriptionStore();
  const [visibleNotifications, setVisibleNotifications] = useState([]);

  useEffect(() => {
    // Show new errors as notifications
    const newErrors = errors?.filter(e => !e.dismissed && !visibleNotifications.find(v => v.id === e.id));

    if (newErrors?.length > 0) {
      setVisibleNotifications(prev => [...prev, ...newErrors]);

      // Auto-dismiss after 5 seconds
      newErrors.forEach(error => {
        setTimeout(() => {
          handleDismiss(error.id);
        }, 2000);
      });
    }
  }, [errors, visibleNotifications]);

  const handleDismiss = (errorId) => {
    setVisibleNotifications(prev => prev.filter(e => e.id !== errorId));
    dismissError(errorId);
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} className="text-green-400" />;
      case 'warning':
        return <AlertTriangle size={20} className="text-yellow-400" />;
      case 'info':
        return <Info size={20} className="text-blue-400" />;
      default:
        return <AlertTriangle size={20} className="text-red-400" />;
    }
  };

  const getNotificationStyles = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-900/90 border-green-500/30 text-green-200';
      case 'warning':
        return 'bg-yellow-900/90 border-yellow-500/30 text-yellow-200';
      case 'info':
        return 'bg-blue-900/90 border-blue-500/30 text-blue-200';
      default:
        return 'bg-red-900/90 border-red-500/30 text-red-200';
    }
  };

  if (visibleNotifications.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
      {visibleNotifications.map((notification, index) => (
        <div
          key={index}
          className={`${getNotificationStyles(notification.type)} border rounded-lg p-4 backdrop-blur-sm animate-slide-left shadow-lg`}
        >
          <div className="flex items-start gap-3 min-w-60">
            {getNotificationIcon(notification.type)}
            <div className="flex-1 ">
              <div className="font-medium text-sm capitalize mb-1">
                {notification.type?.replace('_', ' ') || 'Error'}
              </div>
              <div className="text-sm opacity-90 break-words">
                {notification.message}
              </div>
              {notification.timestamp && (
                <div className="text-xs opacity-60 mt-1">
                  {new Date(notification.timestamp).toLocaleTimeString()}
                </div>
              )}
            </div>
            <button
              onClick={() => handleDismiss(notification.id)}
              className="text-current opacity-60 hover:opacity-100 transition-opacity flex-shrink-0"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationToast;